/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 列举存储空间下的所有文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<string>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/fileName/bucket`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
